<template>
    <div class="quickInx">
        <div v-for="flow in AppList" :key="flow.id" class="applist">
            <div class="img" @click="urlConfig(flow.content)">
                <div><el-image  :fit="fit" :src="flow.icon" ></el-image></div>
                <div style="padding-left: 8px;"><span class="span_text">{{flow.label}}</span></div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                AppList:[],
                fit:"fill",
            }
        },
        mounted:function(){//加载事件
            this.initData();//加载时触发数据填充
        },
        methods:{
            //下面是函数
            initData(){
                let this_ = this;
                let User = JSON.parse(window.sessionStorage.currentUser);
                this.$http.post(`${window.context.portal}/bpm/haiyaapi/getYykjrk?account=`+User.account).then((resp) => {
                    if(resp.data != null){
                        for(let i=0;i<resp.data.length;i++){
                            let arr = JSON.parse(resp.data[i].tb);
                            let host = window.location.hostname;
                            if(host=='127.0.0.1' || host=='localhost' || host=='10.10.10.145'){//内网
                                this_.AppList.push({id:(i+1),label:resp.data[i].yymc,icon:`${window.context.portal}`+"/system/file/v1/downloadFile?fileId="+arr[0].id,content:resp.data[i].nwyylj+User.account});
                            }else{//外网
                                this_.AppList.push({id:(i+1),label:resp.data[i].yymc,icon:`${window.context.portal}`+"/system/file/v1/downloadFile?fileId="+arr[0].id,content:resp.data[i].yylj+User.account});
                            }
                        }
                    }else{
                        $(".quickInx").parents(".el-row").hide();//如果没获取到快捷应用则隐藏菜单栏目
                    }
                });
            },
            urlConfig(item){
                let User = JSON.parse(window.sessionStorage.currentUser);
                let url = "https://shjk.haiya.com.cn/api/user/v1/user/getTokenByUserUserName?username="+User.account;
                if(url==item){
                    this.$http.post(url).then((resp) => {debugger;
                        window.open('https://sh.haiya.com.cn/home?token='+resp.data.value);//拼接token
                    })
                }else{
                    window.open(item);
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
@import "@/assets/css/element-variables.scss";

/deep/ .span_text{
    font-size: 16px;
    font-family: PingFang SC-Semibold, PingFang SC;
    font-weight: 600;
    color: #292B44;
}

/deep/ .img{
    background: #ffffff;
    display: flex;
    align-items: center;
}

/deep/ .applist{
    margin-left: 24px !important;
    margin-right:5% !important;
    display: inline-block;
}

/deep/ .el-image__inner{
    height: 32px;
    width: 32px;
}
</style>
